import classNames from "classnames";
import { setData } from "rivals/shared/utils/qa";
import styles from "./Step.module.scss";
import { Props } from "./types";

function CreateAccountStep({
  children,
  className,
  introNote,
  stepNumber,
  subTitle,
  subTitleClassName,
  title
}: Props): JSX.Element {
  const containerStyles = classNames(styles.container, className);
  return (
    <div className={containerStyles}>
      {introNote && <div className={styles.introNote}>{introNote}</div>}
      <div className={styles.headerContainer}>
        <div
          className={styles.header}
          {...setData("step-number", stepNumber?.toString())}
        >
          {stepNumber && <div className={styles.number}>{stepNumber}</div>}
          {title}
        </div>
        {subTitle && (
          <div className={`${styles.subtitle} ${subTitleClassName}`}>
            {subTitle}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}

export default CreateAccountStep;
